Monitoring.Views.Dashboards ||= {}

class Monitoring.Views.Dashboards.SentimentSelectorView extends Backbone.View
  template: JST['backbone/templates/monitoring/dashboards/sentiment_selector']

  render: ->
    @$el.html(@template())
    @$el.find('#sentiment').chosen(width: '200px')
    @

  clear: ->
    @$el.find('#sentiment').val('').trigger('chosen:updated')

  getValue: ->
    @$el.find('#sentiment').val() if @$el.find('#sentiment').val() != ''

